import {
    Grid,
    TextField } from "../../ui";
import React from "react";
import {
  formatDateInReact,
  formatDateInSnp
} from "../../../constants/constant";
import uiUtilInstance from "../../../utilities/uiUtil";
const DialogDateChange = ({ createdAt, backDateAllowed, setCreatedAt }) => {

    const handleSetDate = (event) => {
        const formatDateVal = formatDateInSnp(event.target.value, createdAt);
        //printLog("handleSetDate",name,value,formatDateVal);
        setCreatedAt(formatDateVal);
    };
    return (
        <Grid container justifyContent="center" alignItems="center" spacing={1} sx={{ p: 1 }}>
            <Grid item xs={12} md={12} sm={12} lg={12}>
                <TextField
                    type="date"
                    id="createdAt"
                    name="createdAt"
                    variant="filled"
                    size="small"
                    disabled={!backDateAllowed}
                    label="Enter Previous Date"
                    value={formatDateInReact(createdAt)}
                    onChange={handleSetDate}
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        inputProps: {
                            min: '2000-01-01',
                            max: formatDateInReact(uiUtilInstance.todayFormattedDate),
                        },
                    }} />
            </Grid>
        </Grid>
    )
};
export default DialogDateChange;